import axiosInstance from "../api/axiosInstance";

// Eventbrite connection (Events design B, step 1, 2026-10-19). The founder
// pastes a Private token from eventbrite.com; the server checks it with
// Eventbrite, stores it encrypted and never sends it back. These calls are
// the only place the token travels: in the PUT body, once. Never a query
// string, never storage, never a log.

export const getEventbriteConnection = () =>
  axiosInstance.get("/admin/integrations/eventbrite");

export const connectEventbrite = (token) =>
  axiosInstance.put("/admin/integrations/eventbrite", { token });

export const disconnectEventbrite = () =>
  axiosInstance.delete("/admin/integrations/eventbrite");
